
import ProductoMax from "./ProductoMax.js";


function Detalles() {
   return (
      <ProductoMax />
  );
}

export default Detalles;